import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
// helpers
import { isTransportRoute } from "../utils/helpers/isTransportRoute";

/**
 * Scrolls to the top when entering a public-transport screen.
 * Uses pathname only (not search params) so in-page URL updates (e.g. SBB station query params) keep scroll position.
 * Temporarily sets manual scroll restoration to avoid the browser restoring a stale position on back/forward.
 */
export function useScrollToTopOnTransportRoute(): void {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (!isTransportRoute(pathname)) {
      return;
    }

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    window.scrollTo(0, 0);

    const rafId = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });

    return () => {
      cancelAnimationFrame(rafId);
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, [pathname]);
}
